import { getFirstReverseSortedKey } from "./objectUtilities";

type NotEmptyObject<T extends Record<`${number}` | number, unknown>> =
  keyof T extends never ? never : T;

/**
 * @param year - Can be any string, but technically it must be of type
 * \``${number}`\` or `number` (not enforced, since years are often typed simply
 * as `string`)
 * @param mapping - Any object (not empty) that uses year (string or number) as a key
 * @returns - Most recent year's mapping, if the year passed in isn't found
 */
export const getYearOrMostRecentValue = <
  Y extends string | number,
  V extends M[Y],
  M extends Record<Y | string | number, V>, // accept any year key
>(
  year: Y,
  mapping: NotEmptyObject<M>
): M[keyof M] => {
  const largestKey = getFirstReverseSortedKey(mapping);
  // `year` will be coerced to a `string`, but just convert it anyway
  return mapping[`${year}`] ?? mapping[largestKey];
};
